import React from 'react';

import { AuthenticationProvider } from './AuthenticationContext';

export * from './AuthenticationContext';

export const AuthenticationGlobalContainer: React.FC = ({ children }) => (
  <AuthenticationProvider>{children}</AuthenticationProvider>
);
